import React, { useState, useMemo } from 'react';
import { LoadingView } from 'src/components/LoadingView';
import moment from 'moment';
import Enumerable from 'linq';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';

import { useQuery, useMutation } from '@tanstack/react-query';
import { useAxiosInstance } from 'src/utils/useAxiosInstance';
import dayjs from 'dayjs';

const UploadHistory = () => {
	const { axiosInstance } = useAxiosInstance();

	const [selectedSort, setSelectedSort, ] = useState({ key: "id", sort: "desc" });

	const headerData = [
		{ id: "id", name: "Upload ID", width_table: 20 },
		{ id: "uploadDate", name: "Upload Date", width_table: 20 },
		{ id: "Records", name: "Records", width_table: 20 },
		{ id: "UploadFile", name: "Upload File", width_table: 12 },
		{ id: "Status", name: "Status", width_table: 28 },
	]

	const { data: fetchData, isFetching } = useQuery({
		queryKey: ['getUploadHistory'],
		queryFn: async () => {
			const response = await axiosInstance.get('/consignment-upload-history?page=1&limit=1000');
			return response.data.uploadHistory;
		},
	});

	const viewFile = useMutation({
    mutationFn: async (documentName) => {
      const res = await axiosInstance.get(
        `/consignment-transfer-order/get-download-file?documentType=view-file&documentName=${documentName}`
      );
      return res.data;
    },
    onSuccess: (data) => {
      window.open(data.data.signedUrl, '_blank');
    },
  });

	const sortedData = useMemo(() => {
    if (fetchData) {
      let sorted = [];
      if (selectedSort.key === 'uploadDate') {
        sorted = Enumerable.from(fetchData)
          .orderByDescending((x) => dayjs(x.uploadDate, 'DD/MM/YYYY').valueOf())
          .toArray();
      } else {
        sorted = Enumerable.from(fetchData)
          .orderByDescending((x) => x[selectedSort.key])
          .toArray();
      }
      return selectedSort.sort === 'desc' ? sorted : sorted.reverse();
    }
    return [];
  }, [fetchData, selectedSort]);

	function handleClickHeader(value) {
		if (value.id === selectedSort.key) {
			setSelectedSort({ key: value.id, sort: selectedSort.sort === "asc" ? "desc" : "asc" });
		} else {
			setSelectedSort({ key: value.id, sort: "asc" });
		}
	}

	const getTableHeaderPrescriber = () => {
		var list = [];

		/* eslint-disable array-callback-return*/
		headerData.map((value, index) => {
			const canSort = ['id', 'uploadDate'].includes(value.id);
			list.push(
				<div key={`header-${value.id}`} className="child" style={{ "--width": value.width_table + "%", cursor: canSort ? "pointer" : "auto" }} onClick={() => canSort && handleClickHeader(value)} >
					{getHeaderPrescriberContent(value)}
				</div>
			)
		})
		/* eslint-enable array-callback-return*/

		return <div className="audience-table-header">{list}</div>
	}

	const getHeaderPrescriberContent = (value) => {
    return (
      <>
        <div className="text">{value.name}</div>
        {value.id === selectedSort.key && (
          <div className="header-sort">
            {selectedSort.sort === 'desc' ? (
              <ArrowDropUpRoundedIcon className="sort-data top selected" />
            ) : (
              <ArrowDropDownRoundedIcon className="sort-data bottom selected" />
            )}
          </div>
        )}
      </>
    );
  };

	const getTableBodyPrescriber = () => {
		var list = [];

		if (sortedData.length === 0) {
			list.push(<div key={`no-data`} className="list no-data">No data available</div>)
		} else {
			sortedData.forEach((value, index) => {
				var last_order_date = "-";

				if (value.uploadDate) {
					last_order_date = moment(value.uploadDate, 'MM-DD-YYYY').format("DD/MM/YYYY");
				}

				list.push(
					<div key={`list-${value.id}`}>
						{index !== 0 ?
							<div key={`nothing-${value.id}`} className="divider-prescribers-mobile hide-desktop"></div>
						: ""}
						<div>
							<div className="list" style={{ "background": "#FFFFFF" }}>
								<div className="child" style={{ "--width": headerData[0].width_table + "%" }}>
									<div className="text" >{value.id}</div>
								</div>
								<div className="child" style={{ "--width": headerData[1].width_table + "%" }}>
									<div className="text">{last_order_date}</div>
								</div>
								<div className="child" style={{ "--width": headerData[2].width_table + "%" }}>
									<div className="text">1</div>
								</div>
								<div className="child" style={{ "--width": headerData[3].width_table + "%" }} onClick={()=> viewFile.mutate(value.uploadFile)}>
									<div className="text view">view</div>
								</div>
								<div className="child" style={{ "--width": headerData[4].width_table + "%" }}>
									<div className="text">
										<div className={`prescribers-status ${value.status === 'open'?'Inactive':'Active'}`}>
											{value.status === 'open'?'Submitted for Approval':'Approved by Cannatrek'}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				)
			})
		}


		return <div key={`table-body`} className="audience-table-body">{list}</div>
	}

	return (
		isFetching ?
			<LoadingView /> :
				<div 
					className="audience-content-table-container" 
				>
					<div className="audience-content-table">
						{getTableHeaderPrescriber()}
						{getTableBodyPrescriber()}
					</div>
				</div>
	)

}

export default UploadHistory;